module.exports = __webpack_public_path__ + "static/media/deep_refresh_sky.76b2c899.png";